import { createAsyncThunk } from '@reduxjs/toolkit';
import selectApiBaseUrl from '../../env/selectors/selectApiBaseUrl';

export default createAsyncThunk('sso/getUri', async (organizationName, { getState }) => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const apiBaseUrl = selectApiBaseUrl(getState());

  const response = await fetch(`${apiBaseUrl}/sso/identity-uri?label=${encodeURIComponent(organizationName)}`, options);
  if (!response.ok) throw new Error(await response.text());
  const data = await response.json();
  if (!data.url) throw new Error(data.message);

  return data.url;
});
